/**
 * 游戏注册表
 * 管理所有可用游戏
 */

// 游戏配置列表
const gameConfigs = [
  {
    id: 'puzzle-animal',
    name: { zh: '动物拼图', en: 'Animal Puzzle' },
    description: { 
      zh: '拖拽拼图块完成可爱的动物图片', 
      en: 'Drag puzzle pieces to complete cute animal pictures' 
    },
    icon: '🦁',
    category: 'puzzle',
    themeColor: '#FFD93D',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'memory-match',
    name: { zh: '记忆配对', en: 'Memory Match' },
    description: { 
      zh: '翻转卡片找到相同的配对', 
      en: 'Flip cards to find matching pairs' 
    },
    icon: '🎴',
    category: 'memory',
    themeColor: '#9B59B6',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'math-adventure',
    name: { zh: '数学冒险', en: 'Math Adventure' },
    description: { 
      zh: '通过数学题目挑战你的大脑', 
      en: 'Challenge your brain with math problems' 
    },
    icon: '🔢',
    category: 'math',
    themeColor: '#10B981',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'creative-canvas',
    name: { zh: '创意绘画', en: 'Creative Canvas' },
    description: { 
      zh: '自由绘画创作你的作品', 
      en: 'Draw and create your own artwork' 
    },
    icon: '🎨',
    category: 'creative',
    themeColor: '#EC4899',
    features: {
      hasDifficulty: false,
      hasTimer: false,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'rhythm-master',
    name: { zh: '节奏大师', en: 'Rhythm Master' },
    description: { 
      zh: '跟随音乐节奏点击对应颜色', 
      en: 'Follow the rhythm and tap the colors' 
    },
    icon: '🎵',
    category: 'music',
    themeColor: '#F59E0B',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'maze-adventure',
    name: { zh: '迷宫探险', en: 'Maze Adventure' },
    description: { 
      zh: '在迷宫中找到出口', 
      en: 'Find your way out of the maze' 
    },
    icon: '🎮',
    category: 'puzzle',
    themeColor: '#E94560',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'quick-reflex',
    name: { zh: '快速反应', en: 'Quick Reflex' },
    description: { 
      zh: '测试你的反应速度', 
      en: 'Test your reaction speed' 
    },
    icon: '⚡',
    category: 'reaction',
    themeColor: '#FF6B6B',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'color-sort',
    name: { zh: '颜色分类', en: 'Color Sort' },
    description: { 
      zh: '将物品按颜色分类', 
      en: 'Sort items by color' 
    },
    icon: '🎨',
    category: 'puzzle',
    themeColor: '#FF6B9D',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'interactive-story',
    name: { zh: '互动故事', en: 'Interactive Story' },
    description: { 
      zh: '选择你的冒险故事', 
      en: 'Choose your own adventure story' 
    },
    icon: '📖',
    category: 'story',
    themeColor: '#8B5CF6',
    features: {
      hasDifficulty: false,
      hasTimer: false,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'physics-lab',
    name: { zh: '物理实验室', en: 'Physics Lab' },
    description: { 
      zh: '探索重力、弹力和碰撞', 
      en: 'Explore gravity, elasticity and collisions' 
    },
    icon: '🔬',
    category: 'science',
    themeColor: '#FF6B35',
    features: {
      hasDifficulty: false,
      hasTimer: false,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'word-spelling',
    name: { zh: '单词拼写', en: 'Word Spelling' },
    description: { 
      zh: '拼写单词学习英语', 
      en: 'Spell words to learn English' 
    },
    icon: '📝',
    category: 'english',
    themeColor: '#4ECDC4',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'shape-match',
    name: { zh: '形状匹配', en: 'Shape Match' },
    description: { 
      zh: '匹配相同的形状', 
      en: 'Match the same shapes' 
    },
    icon: '🔷',
    category: 'puzzle',
    themeColor: '#667EEA',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'sudoku-junior',
    name: { zh: '数独入门', en: 'Sudoku Junior' },
    description: { 
      zh: '儿童版数独游戏', 
      en: 'Kids version of Sudoku' 
    },
    icon: '🔢',
    category: 'math',
    themeColor: '#43A047',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'link-match',
    name: { zh: '连连看', en: 'Link Match' },
    description: { 
      zh: '连接相同的图案', 
      en: 'Connect matching patterns' 
    },
    icon: '🔗',
    category: 'puzzle',
    themeColor: '#667EEA',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'whack-a-mole',
    name: { zh: '打地鼠', en: 'Whack-a-Mole' },
    description: { 
      zh: '快速点击出现的地鼠', 
      en: 'Quickly tap the appearing moles' 
    },
    icon: '🔨',
    category: 'reaction',
    themeColor: '#5D4037',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'fruit-catcher',
    name: { zh: '接水果', en: 'Fruit Catcher' },
    description: { 
      zh: '移动篮子接住水果', 
      en: 'Move the basket to catch fruits' 
    },
    icon: '🍎',
    category: 'reaction',
    themeColor: '#87CEFA',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'color-by-number',
    name: { zh: '涂色本', en: 'Color by Number' },
    description: { 
      zh: '按数字涂色完成画作', 
      en: 'Color by number to complete the picture' 
    },
    icon: '🖍️',
    category: 'creative',
    themeColor: '#FF6B9D',
    features: {
      hasDifficulty: false,
      hasTimer: false,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'spot-difference',
    name: { zh: '找不同', en: 'Spot the Difference' },
    description: { 
      zh: '找出两幅图的不同之处', 
      en: 'Find differences between two pictures' 
    },
    icon: '🔍',
    category: 'puzzle',
    themeColor: '#FF6B9D',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'sorting-challenge',
    name: { zh: '排序挑战', en: 'Sorting Challenge' },
    description: { 
      zh: '按大小或颜色排序', 
      en: 'Sort by size or color' 
    },
    icon: '🎯',
    category: 'puzzle',
    themeColor: '#8B5CF6',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'time-master',
    name: { zh: '时钟学习', en: 'Time Master' },
    description: { 
      zh: '学习认识时间', 
      en: 'Learn to tell time' 
    },
    icon: '🕐',
    category: 'math',
    themeColor: '#10B981',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'path-finder',
    name: { zh: '迷宫寻路', en: 'Path Finder' },
    description: { 
      zh: '在迷宫中找到最短路径', 
      en: 'Find the shortest path in the maze' 
    },
    icon: '🧭',
    category: 'puzzle',
    themeColor: '#8B5CF6',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'speed-math',
    name: { zh: '速算挑战', en: 'Speed Math' },
    description: { 
      zh: '快速计算数学题目', 
      en: 'Quickly solve math problems' 
    },
    icon: '⚡',
    category: 'math',
    themeColor: '#3B82F6',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'balance-builder',
    name: { zh: '平衡搭建', en: 'Balance Builder' },
    description: { 
      zh: '堆叠方块保持平衡', 
      en: 'Stack blocks while keeping balance' 
    },
    icon: '⚖️',
    category: 'physics',
    themeColor: '#667EEA',
    features: {
      hasDifficulty: true,
      hasTimer: false,
      hasScore: true,
      hasSound: true,
      hasLangSwitch: true
    }
  },
  {
    id: 'pipe-connect',
    name: { zh: '管道连接', en: 'Pipe Connect' },
    description: { 
      zh: '旋转管道连接水流', 
      en: 'Rotate pipes to connect the water flow' 
    },
    icon: '🔧',
    category: 'puzzle',
    themeColor: '#4299E1',
    features: {
      hasDifficulty: true,
      hasTimer: true,
      hasScore: false,
      hasSound: true,
      hasLangSwitch: true
    }
  }
];

class GameRegistry {
  constructor() {
    this.configs = new Map();
    this.modules = new Map();
    
    // 注册所有游戏
    gameConfigs.forEach(config => {
      this.configs.set(config.id, config);
    });
  }
  
  /**
   * 获取游戏配置
   * @param {string} id
   * @returns {object|undefined}
   */
  get(id) {
    return this.configs.get(id);
  }
  
  /**
   * 检查游戏是否存在
   * @param {string} id
   * @returns {boolean}
   */
  has(id) {
    return this.configs.has(id);
  }
  
  /**
   * 获取所有游戏配置
   * @returns {object[]}
   */
  getAll() {
    return Array.from(this.configs.values());
  }
  
  /**
   * 按分类获取游戏
   * @param {string} category
   * @returns {object[]}
   */
  getByCategory(category) {
    return this.getAll().filter(config => config.category === category);
  }
  
  /**
   * 动态加载游戏模块
   * @param {string} id
   * @returns {Promise}
   */
  async load(id) {
    // 检查缓存
    if (this.modules.has(id)) {
      return this.modules.get(id);
    }
    
    // 动态导入
    try {
      const module = await import(`./${id}/index.js`);
      this.modules.set(id, module);
      return module;
    } catch (err) {
      console.error(`Failed to load game module: ${id}`, err);
      throw err;
    }
  }
  
  /**
   * 预加载游戏模块
   * @param {string} id
   */
  preload(id) {
    if (!this.modules.has(id)) {
      this.load(id).catch(console.error);
    }
  }
  
  /**
   * 获取分类列表
   * @returns {string[]}
   */
  getCategories() {
    const categories = new Set();
    this.configs.forEach(config => categories.add(config.category));
    return Array.from(categories);
  }
}

export const gameRegistry = new GameRegistry();
